/***
 * Key to save last company.
 */
export const restHelpCurCompStorageKey = 'RestHelpCurComp';

/***
 * Key to save last version used.
 */
export const restHelpVersionStorageKey = 'RestHelpVersion';

/***
 * Path where application will be installed.
 */
export const appsSubPath = '/apps/';
